<template>
  <v-app-bar color="primary" dark app>
    <v-app-bar-nav-icon @click="handleDrawerToggle" />
    {{ current_user.first_name }} {{ current_user.last_name }}

    <v-spacer />
    <search-app-bar class="ml-4" />

    <v-toolbar-items>
      <v-btn icon @click="$router.push('/profile').catch(() => {})">
        <v-icon>mdi-account-circle</v-icon>
      </v-btn>
      <v-btn icon @click="logout">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-toolbar-items>
    <v-toolbar
      v-if="extended"
      slot="extension"
      tag="div"
      dense
      color="white"
      light
    >
      <v-icon>mdi-home</v-icon>
      <v-breadcrumbs :items="breadcrumbs" class="pa-3" />
      <v-spacer></v-spacer>
      <v-btn icon small color="black">
        <v-icon @click="handleGoBack" v-text="'mdi-arrow-left'" />
      </v-btn>
    </v-toolbar>
  </v-app-bar>
</template>
<script>
import { mapGetters } from "vuex"
import { AUTH_LOGOUT } from "@/store/actions/auth"
import { mapActions } from "vuex"
import SearchAppBar from "./header/Search"

export default {
  name: "AppToolbar",
  components: {
    SearchAppBar,
  },
  props: {
    extended: Boolean,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(["getAvatar", "getUsername", "getNotification"]),
    current_user() {
      return this.$store.state.user.profile
    },
    users() {
      return this.$store.state.user.data
    },
    breadcrumbs() {
      const { matched } = this.$route
      let routes = matched.map((route, index) => {
        const to =
          index === matched.length - 1
            ? this.$route.path
            : route.path || route.redirect
        const text = this.$t("main-nav." + route.name)
        return {
          text: text,
          to: to,
          exact: true,
          disabled: false,
        }
      })
      let user_id = Number(this.$route.params.user_id)
      if (user_id) {
        let user = this.users.find((item) => item.id === user_id)
        if (user) {
          routes.splice(-1, 0, {
            text: user.first_name + " " + user.last_name,
            to: "/users/" + user.id,
            exact: true,
            disabled: false,
          })
        }
      }
      return routes
    },
  },
  created() {},
  methods: {
    ...mapActions("auth", [AUTH_LOGOUT]),

    handleDrawerToggle() {
      this.$emit("side-icon-click")
    },
    logout() {
      this.AUTH_LOGOUT()
      this.$router.push("/login")
    },

    handleSetting() {},
    handleProfile() {},
    handleGoBack() {
      this.$router.go(-1)
    },
  },
}
</script>
